<template>
  <div>
    <app-spinner v-if="!is_page_loaded" />
    <app-page-container v-else>
      <template v-if="new_reservations.length > 0">
        <h2 class="title title--mb15">New request</h2>
        <AppAccSafari
          v-for="(safari, safari_index) in new_reservations"
          :key="`new_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
          :countdown="safari.sales_status_last_updated_at"
        />
        <app-cells :position="pagination_new.pages > 1 ? 'between' : 'end'">
          <paginate
              :clickHandler="onClickNewPagination"
              v-if="pagination_new.pages > 1"
              v-model="pagination_new.page"
              :page-count="pagination_new.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination_new.count" :count="new_reservations.length" :page="pagination_new.page" />
        </app-cells>
      </template>
      <template v-if="amendment_requested.length > 0">
        <h2 class="title title--mb15">Amendment request</h2>
        <AppAccSafari
          v-for="(safari, safari_index) in amendment_requested"
          :key="`amendment_requested_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_amendment_requested.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickAmendmentRequestedPagination"
            v-if="pagination_amendment_requested.pages > 1"
            v-model="pagination_amendment_requested.page"
            :page-count="pagination_amendment_requested.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_amendment_requested.count"
            :count="amendment_requested.length"
            :page="pagination_amendment_requested.page"
          />
        </app-cells>
      </template>
      <template v-if="cancellation_requested.length > 0">
        <h2 class="title title--mb15">Cancellation request</h2>
        <AppAccSafari
          v-for="(safari, safari_index) in cancellation_requested"
          :key="`cancellation_requested_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_cancellation_requested.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickCancellationRequestedPagination"
            v-if="pagination_cancellation_requested.pages > 1"
            v-model="pagination_cancellation_requested.page"
            :page-count="pagination_cancellation_requested.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_cancellation_requested.count"
            :count="cancellation_requested.length"
            :page="pagination_cancellation_requested.page"
          />
        </app-cells>
      </template>
      <template v-if="confirm_booking_reservations.length > 0">
        <h2 class="title title--mb15">Confirmation request</h2>
        <AppAccSafari
          v-for="(safari, safari_index) in confirm_booking_reservations"
          :key="`confirm_booking_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_confirm_booking.pages > 1 ? 'between' : 'end'">
          <paginate
              :clickHandler="onClickConfirmBookingPagination"
              v-if="pagination_confirm_booking.pages > 1"
              v-model="pagination_confirm_booking.page"
              :page-count="pagination_confirm_booking.pages"
              :prev-text="'<'"
              :next-text="'>'"
              :container-class="'pagination'"
              :page-class="'pagination__item'"
              :page-link-class="'pagination__link'"
              :prev-class="'pagination__item pagination__item--prev'"
              :next-class="'pagination__item pagination__item--next'"
              :next-link-class="'pagination__link pagination__link--next'"
              :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_confirm_booking.count"
            :count="confirm_booking_reservations.length"
            :page="pagination_confirm_booking.page"
          />
        </app-cells>
      </template>
      <template v-if="in_process_reservations.length > 0">
        <h2 class="title title--mb15">In process</h2>
        <AppAccSafari
          v-for="(safari, safari_index) in in_process_reservations"
          :key="`in_process_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_in_process.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickInProcessPagination"
            v-if="pagination_in_process.pages > 1"
            v-model="pagination_in_process.page"
            :page-count="pagination_in_process.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
            :all="pagination_in_process.count"
            :count="in_process_reservations.length"
            :page="pagination_in_process.page"
          />
        </app-cells>
      </template>
      <template v-if="booked_provisionally_reservations.length > 0">
        <app-cells :indent="false" margin-bottom="15px">
          <h2 class="title">Booked provisionally</h2>
          <app-filters
            @change="fetchBookedProvisionallyReservations"
            v-model="filter_booked_provisionally"
            :filters="filters_booked_provisionally"
            name="filterTransfers"
          />
        </app-cells>
        <AppAccSafari
          v-for="(safari, safari_index) in booked_provisionally_reservations"
          :key="`booked_provisionally_${safari.id}`"
          :reservation="safari"
          :order-number="safari_index + 1"
        />
        <app-cells :position="pagination_booked_provisionally.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickBookedProvisionallyPagination"
            v-if="pagination_booked_provisionally.pages > 1"
            v-model="pagination_booked_provisionally.page"
            :page-count="pagination_booked_provisionally.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records
              :all="pagination_booked_provisionally.count"
              :count="booked_provisionally_reservations.length"
              :page="pagination_booked_provisionally.page"
          />
        </app-cells>
      </template>
    </app-page-container>
  </div>
</template>

<script>
import { getReservationsSafari } from '@/http'
import AppAccSafari from '@/components/AppAccSafari.vue'

export default {
  name: 'SafariReservationsListUpcoming',
  components: { AppAccSafari },
  data() {
    return {
      is_page_loaded: false,
      new_reservations: [],
      amendment_requested: [],
      cancellation_requested: [],
      confirm_booking_reservations: [],
      in_process_reservations: [],
      booked_provisionally_reservations: [],
      pagination_new: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_amendment_requested: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_cancellation_requested: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_confirm_booking: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_in_process: {
        pages: 1,
        page: 1,
        count: 1,
      },
      pagination_booked_provisionally: {
        pages: 1,
        page: 1,
        count: 1,
      },
      filter_booked_provisionally: 'tour_start',
      filters_booked_provisionally: [
        { value: 'tour_start', label: 'Tour start' },
        { value: 'deadline', label: 'Deadline' },
      ],
    }
  },
  created () {
    this.fetchReservations()
  },
  methods: {
    fetchReservations() {
      Promise.all([
        getReservationsSafari({
          reservation_status: 'new',
          sales_status_exclude: 'cancel',
          processing: false,
          ordering: 'sales_status_last_updated_at',
          page: this.pagination_new.page,
          page_size: 20,
        }),
        getReservationsSafari({
          amendment: true,
          page: this.pagination_amendment_requested.page,
          page_size: 20,
        }),
        getReservationsSafari({
          reservation_status_exclude: 'cancelled',
          sales_status: 'cancel',
          processing: false,
          ordering: 'sales_status_last_updated_at',
          page: this.pagination_cancellation_requested.page,
          page_size: 20,
        }),
        getReservationsSafari({
          category: 'upcoming',
          reservation_status_exclude: 'booked,new',
          sales_status: 'book',
          processing: false,
          ordering: 'sales_status_last_updated_at',
          page: this.pagination_confirm_booking.page,
          page_size: 20,
        }),
        getReservationsSafari({
          reservation_status: 'in_process',
          ordering: 'sales_status_last_updated_at',
          page: this.pagination_in_process.page,
          page_size: 20,
        }),
        getReservationsSafari({
          reservation_status: 'booked_provisionally',
          sales_status_exclude: 'book,cancel',
          provisional_extension: false,
          ordering: this.filter_booked_provisionally === 'tour_start' ? '' : 'reservation_deadline',
          page: this.pagination_booked_provisionally.page,
          page_size: 20,
        }),
      ])
        .then(res => {
          this.new_reservations = res[0].data.results
          this.pagination_new.pages = res[0].data.pages
          this.pagination_new.count = res[0].data.count

          this.amendment_requested = res[1].data.results
          this.pagination_amendment_requested.pages = res[1].data.pages
          this.pagination_amendment_requested.count = res[1].data.count

          this.cancellation_requested = res[2].data.results
          this.pagination_cancellation_requested.pages = res[2].data.pages
          this.pagination_cancellation_requested.count = res[2].data.count

          this.confirm_booking_reservations = res[3].data.results
          this.pagination_confirm_booking.pages = res[3].data.pages
          this.pagination_confirm_booking.count = res[3].data.count

          this.in_process_reservations = res[4].data.results
          this.pagination_in_process.pages = res[4].data.pages
          this.pagination_in_process.count = res[4].data.count

          this.booked_provisionally_reservations = res[5].data.results
          this.pagination_booked_provisionally.pages = res[5].data.pages
          this.pagination_booked_provisionally.count = res[5].data.count

          this.is_page_loaded = true
        })
    },
    fetchNewReservations() {
      getReservationsSafari({
        reservation_status: 'new',
        sales_status_exclude: 'cancel',
        processing: false,
        ordering: 'sales_status_last_updated_at',
        page: this.pagination_new.page,
        page_size: 20,
      })
        .then(res => {
          this.new_reservations = res.data.results
          this.pagination_new.pages = res.data.pages
          this.pagination_new.count = res.data.count
        })
    },
    fetchAmendmentRequested() {
      getReservationsSafari({
        amendment: true,
        page: this.pagination_amendment_requested.page,
        page_size: 20,
      })
        .then(res => {
          this.amendment_requested = res.data.results
          this.pagination_amendment_requested.pages = res.data.pages
          this.pagination_amendment_requested.count = res.data.count
        })
    },
    fetchCancellationRequested() {
      getReservationsSafari({
        reservation_status_exclude: 'cancelled',
        sales_status: 'cancelled',
        processing: false,
        ordering: 'sales_status_last_updated_at',
        page: this.pagination_cancellation_requested.page,
        page_size: 20,
      })
        .then(res => {
          this.cancellation_requested = res.data.results
          this.pagination_cancellation_requested.pages = res.data.pages
          this.pagination_cancellation_requested.count = res.data.count
        })
    },
    fetchConfirmBookingReservations() {
      getReservationsSafari({
        category: 'upcoming',
        reservation_status_exclude: 'booked,new',
        sales_status: 'book',
        processing: false,
        ordering: 'sales_status_last_updated_at',
        page: this.pagination_confirm_booking.page,
        page_size: 20,
      })
        .then(res => {
          this.confirm_booking_reservations = res.data.results
          this.pagination_confirm_booking.pages = res.data.pages
          this.pagination_confirm_booking.count = res.data.count
        })
    },
    fetchInProcessReservations() {
      getReservationsSafari({
        reservation_status: 'in_process',
        ordering: 'sales_status_last_updated_at',
        page: this.pagination_in_process.page,
        page_size: 20,
      })
        .then(res => {
          this.in_process_reservations = res.data.results
          this.pagination_in_process.pages = res.data.pages
          this.pagination_in_process.count = res.data.count
        })
    },
    fetchBookedProvisionallyReservations() {
      getReservationsSafari({
        reservation_status: 'booked_provisionally',
        sales_status_exclude: 'book,cancel',
        provisional_extension: false,
        ordering: this.filter_booked_provisionally === 'tour_start' ? '' : 'reservation_deadline',
        page: this.pagination_booked_provisionally.page,
        page_size: 20,
      })
        .then(res => {
          this.booked_provisionally_reservations = res.data.results
          this.pagination_booked_provisionally.pages = res.data.pages
          this.pagination_booked_provisionally.count = res.data.count
        })
    },
    onClickNewPagination(page) {
      this.pagination_new.page = page
      this.fetchNewReservations()
    },
    onClickAmendmentRequestedPagination(page) {
      this.pagination_amendment_requested.page = page
      this.fetchAmendmentRequested()
    },
    onClickCancellationRequestedPagination(page) {
      this.pagination_cancellation_requested.page = page
      this.fetchCancellationRequested()
    },
    onClickConfirmBookingPagination(page) {
      this.pagination_confirm_booking.page = page
      this.fetchConfirmBookingReservations()
    },
    onClickInProcessPagination(page) {
      this.pagination_in_process.page = page
      this.fetchInProcessReservations()
    },
    onClickBookedProvisionallyPagination(page) {
      this.pagination_booked_provisionally.page = page
      this.fetchBookedProvisionallyReservations()
    },
  }
}
</script>
